// extracted by mini-css-extract-plugin
export default {"lds-ellipsis":"lds-ellipsis__4R+VE","lds-ellipsis1":"lds-ellipsis1__G5ulj","lds-ellipsis2":"lds-ellipsis2__lf9S0","lds-ellipsis3":"lds-ellipsis3__XegZ-"};